<template>
  <div id="app">
    <!-- TOPBAR (opsional) -->
    <!-- <Topbar /> -->

    <!-- NAVBAR -->
    <MainNavbar />

    <!-- KONTEN UTAMA -->
    <router-view />

    <!-- FOOTER -->
    <PageFooters />

    <!-- PRELOADER -->
    <!-- <div id="preloader">
      <div class="preloader-position">
        <img src="/assets/img/logo-colored.png" alt="logo" />
        <div class="progress">
          <div class="indeterminate"></div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { onMounted } from 'vue' // ✅ Tambahkan ini
// Pastikan komponen sudah di-import
import MainNavbar from './components/MainNavbar.vue'
import PageFooters from './components/PageFooters.vue'
// import Topbar from './components/Topbar.vue' // Kalau ingin dipakai

onMounted(() => {
  setTimeout(() => {
    if (window.initCustomJS) window.initCustomJS()
  }, 100)
})
</script>

<style>
/* Jika ada style preloader, bisa ditempatkan di sini atau dalam file global */
#preloader {
  position: fixed;
  background: #fff;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.preloader-position {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.indeterminate {
  width: 100px;
  height: 5px;
  background: #007bff;
  animation: loading 1.5s infinite;
}
@keyframes loading {
  0% { margin-left: 0; width: 0; }
  50% { width: 100px; }
  100% { margin-left: 100px; width: 0; }
}
</style>


